'use strict';

var base = require('@pixi-spine/base');

class SkeletonBounds extends base.SkeletonBoundsBase {
}

exports.SkeletonBounds = SkeletonBounds;
//# sourceMappingURL=SkeletonBounds.js.map
